module.exports = __webpack_public_path__ + "img/2018.9de87605.jpg";